import React from 'react';
import { MarketplaceData } from 'app/console-api/marketplace/marketplace';
import { StyledCardRow, StyledIconLink } from 'app/components/common/common-styles';
import { BodyText, Button, FlexColumn, FlexRow, TableData } from '@make-software/cspr-design';
import { CategoryTag } from 'app/components/common/categories/category-tag';
import { DealTradeChip } from 'app/components/common/deal-trade-type/deal-trade-chip';
import { AppType } from 'app/components/common/apps/app-type';
import { generatePath, useNavigate } from 'react-router-dom';
import { PUBLIC_APP_VIEW_PATH, MARKETPLACE_APP_OFFERS_PATH } from 'app/route/paths';
import LinkIcon from 'assets/icons/ic-link.svg';
import styled from 'styled-components';

const StyledInfoName = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '13px',
    lineHeight: '20px',
    color: theme.styleguideColors.contentSecondary
  })
);

interface MarketplaceAppItemProps {
  data: MarketplaceData;
}

export const MarketplaceAppItem = ({ data }: MarketplaceAppItemProps) => {
  const navigate = useNavigate();

  const handleViewApp = () => {
    navigate(generatePath(PUBLIC_APP_VIEW_PATH, { appId: data.app.id }));
  };

  const handleSeeOffers = () => {
    navigate(generatePath(MARKETPLACE_APP_OFFERS_PATH, { appId: data.app.id }));
  };

  return (
    <StyledCardRow>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <BodyText size={1}>{data.app.name}</BodyText>
            <StyledIconLink onClick={handleViewApp} src={LinkIcon} size={16} />
          </FlexRow>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            {data.app.description}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Type:</StyledInfoName>
            <AppType type={data.app.type} />
          </FlexRow>
          <FlexRow gap={4} wrap={'wrap'}>
            {data.tradeTypes.map((t) => (
              <DealTradeChip key={t} type={t} />
            ))}
          </FlexRow>
          <FlexRow gap={4} wrap={'wrap'}>
            {data.app.categories.map((cat) => (
              <CategoryTag key={cat} name={cat} />
            ))}
          </FlexRow>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>MAU:</StyledInfoName>
            <BodyText size={3} scale={'sm'} monotype>
              {data.app.mau.toLocaleString()}
            </BodyText>
          </FlexRow>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>DAU:</StyledInfoName>
            <BodyText size={3} scale={'sm'} monotype>
              {data.app.dau.toLocaleString()}
            </BodyText>
          </FlexRow>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Offers:</StyledInfoName>
            <BodyText size={3} scale={'sm'} monotype>
              {data.activeOffers}
            </BodyText>
          </FlexRow>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Updated:</StyledInfoName>
            <BodyText size={3} scale={'sm'}>
              {new Date(data.lastUpdated).toLocaleDateString()}
            </BodyText>
          </FlexRow>
        </FlexColumn>
      </TableData>
      <TableData align="right">
        <Button onClick={handleSeeOffers}>See offers</Button>
      </TableData>
    </StyledCardRow>
  );
};
